import TYPES from '../../action-types';

/**
 * Get indexing status for visual search for collection
 * @param {string} collectionID
 */
function incrementIndexingStatus(data) {
  return async (dispatch, getState) => {
    const { router, collections } = getState();
    const currentCollectionId = router.location.query.collectionIds;

    // when multiple collections are selected, we don't need to increment the indexing status
    if (Array.isArray(currentCollectionId)) {
      return;
    }

    dispatch({
      type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.START,
    });

    const indexedAssetsCount = data.assets.reduce((acc, asset) => {
      if (asset.tags.some((tag) => tag._id === currentCollectionId)) {
        return acc + 1;
      }
      return acc;
    }, collections.aiIndexedAssetsCount);

    try {
      dispatch({
        type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.COMPLETE,
        payload: {
          collectionID: currentCollectionId,
          indexedAssetsCount,
          notIndexedAssetsCount: collections.aiNotIndexedAssetsCount,
        },
      });
    } catch (error) {
      dispatch({
        type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.FAILED,
        payload: {
          collectionID: currentCollectionId,
        },
      });
    }
  };
}

export default incrementIndexingStatus;
